import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { set } from 'lodash';
import { Button, Form } from 'react-bootstrap';

import { PutReservation } from 'entities/Reservations';
import Loader from 'modules/kiosk/components/Loader';
import { useModal } from 'modules/shared/hooks';
import BookModal from 'modules/shared/BookingTable/components/BookModal';
import ModalWrapper from 'modules/shared/ModalWrapper';
import YesNoModal from 'modules/shared/YesNoModal';
import { putBookRequest } from 'modules/manager/containers/Booking/services/actions';

import { bookingModalSelector } from './selector';
import { cleanBookState } from './actions';
import styleInput from '../../shared/Forms/Input/Input.module.scss';

type Props = {
  schema: any;
  onBook: any;
  mode: 'director' | 'manager' | 'ordering';
};

// TODO другой менеджер
// TODO завкслад (подтверждение, отклонение)
// TODO менеджер (сохранение, перенос)

const BookingModal: React.FC<Props> = ({ schema, onBook, mode }) => {
  const dispatch = useDispatch();
  const { bookCell, editBook, ordersError, loading } = useSelector(bookingModalSelector);

  const { isShow, openModal, closeModal } = useModal();
  const { isShow: isShowYN, openModal: openModalYN, closeModal: closeModalYN } = useModal();
  // const { isShow: isShowCancelYN, openModal: openModalCancelYN, closeModal: closeModalCancelYN } = useModal();
  const { isShow: isShowDelete, openModal: openIsShowDelete, closeModal: closeIsShowDelete } = useModal();
  const isManager = mode === 'manager';
  const isDirector = mode === 'director';
  const [titleModalYN, setTitleModalYN] = useState('');
  const [comment, setComment] = useState('');

  const formRef = useRef();

  // const onRemoveOrder = (values: any, index: number) => {
  //   // @ts-ignore
  //   const { setFieldValue } = formRef.current;
  //   setFieldValue(`orders[${index}].isDeleted`, true);
  //
  //   dispatch(setModalEditBook(values));
  // };

  const handleChangeComment = (e: any) => setComment(e.target.value);

  const onClearStateModalYN = () => {
    setTitleModalYN('');
    closeModalYN();
  };

  const onClearBookState = () => {
    onClearStateModalYN();
    closeModal();
    dispatch(cleanBookState());
  };

  const handleSubmit = () => {
    // @ts-ignore
    const { values } = formRef.current;
    if (isDirector && values?.bookingStatus !== 4) {
      set(values, 'bookingStatus', 2);
    }
    // @ts-ignore
    onBook(values);
    onClearStateModalYN();
  };

  const onSubmitHandler = (values: any) => {
    if (isDirector) {
      if (values?.bookingStatus === 4) {
        setTitleModalYN('Відхилити бронь');
      } else {
        setTitleModalYN('Підтвердити бронь');
      }
    } else {
      setTitleModalYN('Зберегти бронь');
    }
    formRef.current = values;
    openModalYN();
  };

  const onDeleteBook = () => {
    // @ts-ignore
    const { values } = formRef.current;

    const params: PutReservation = {
      reservationId: values?.id,
      bookingStatus: 3,
      comment,
    };

    dispatch(putBookRequest(params));
    return onClearBookState();
  };

  const onDecline = () => {
    // @ts-ignore
    const { values } = formRef.current;
    set(values, 'bookingStatus', 4);
    set(values, 'comment', comment);

    onBook(values);
  };

  useEffect(() => {
    if (bookCell) {
      return openModal();
    }
    closeModal();
  }, [bookCell, editBook]);

  return (
    <div>
      {loading && <Loader />}
      <BookModal
        isShow={isShow}
        bookValues={editBook}
        bookCell={bookCell}
        formRef={formRef}
        schema={schema}
        mode={mode}
        ordersError={ordersError}
        onCloseModal={() => {
          onClearStateModalYN();
          closeModal();
          dispatch(cleanBookState());
        }}
        onSubmit={onSubmitHandler}
        onDeleteBook={openIsShowDelete}
        onDecline={openIsShowDelete}
      />

      <YesNoModal
        className="modalOver"
        isShow={isShowYN}
        title={titleModalYN}
        acceptHandler={handleSubmit}
        closeModal={onClearStateModalYN}
      />

      {/* <YesNoModal */}
      {/*  className="modalOver" */}
      {/*  isShow={isShowCancelYN} */}
      {/*  title="Вийти з бронювання" */}
      {/*  acceptHandler={onClearBookState} */}
      {/*  closeModal={closeModalCancelYN} */}
      {/* /> */}

      <ModalWrapper className="modalOver" show={isShowDelete} onHide={closeIsShowDelete}>
        <div>
          <h6 className="text-center">Вкажіть причину {isManager ? 'видалення' : 'відхилення'} броні</h6>
          <Form.Control
            className={styleInput.input}
            value={comment}
            onChange={handleChangeComment}
            autoComplete="off"
            as="textarea"
            rows={3}
            required
          />
          <div className="d-flex justify-content-center mt-3">
            <Button
              className="px-5"
              variant="outline-secondary"
              onClick={isManager ? onDeleteBook : onDecline}
              disabled={comment.length < 4}
            >
              {isManager ? 'Видалити' : 'Відхилити'}
            </Button>
          </div>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default BookingModal;
